import React from "react";
import { ApolloErrorGuard } from "../../../shared/ApolloErrorGuard/ApolloErrorGuard";
import { useQuery } from "react-apollo";
import { GET_TOP_SALES_PRODUCTS, GetTopSalesProductsVariables } from "../../../../queries/home";
import { SlideShow } from "../../../SlideShow/SlideShow";
import { Container } from "../../../Container/Container";
import { useProductCategoryFilter } from "../../../../lib/hooks/useProductCategoryFilter";

import "./TopSale.scss";

export const TopSale = () => {
  const categoryFilter = useProductCategoryFilter();
  const { loading, error, data } = useQuery<any, GetTopSalesProductsVariables>(GET_TOP_SALES_PRODUCTS, {
    variables: {
      categoryIn: categoryFilter?.map(id => parseInt(id, 10)),
    },
  });

  const products = data?.products?.nodes || [];

  if (products.length === 0) {
    return null;
  }

  return (
    <div className="TopSale animate__animated animate__fadeIn">
      <ApolloErrorGuard error={error}>
        <Container>
          <SlideShow
            loading={loading}
            error={error}
            items={products}
            title="Produktet aktuale"
            redirectLink="tenxehta=true"
          />
        </Container>
      </ApolloErrorGuard>
    </div>
  );
};
